'use client';

import { FlagsmithProvider } from 'flagsmith/react';

import { FeatureFlagService } from '@/utils/services/FeatureFlagService';

type FlagsmithProviderWrapperProps = {
    children: React.ReactNode;
};

export function FlagsmithProviderWrapper({ children }: FlagsmithProviderWrapperProps) {
    return (
        <FlagsmithProvider
            flagsmith={FeatureFlagService.flagsmith}
            options={{
                environmentID: process.env.NEXT_PUBLIC_FLAGSMITH_KEY,
                api: process.env.NEXT_PUBLIC_FLAGSMITH_API_URL,
                /**
                 * Disable flag caching in localStorage.
                 * Flags are fetched fresh instead of being persisted across reloads.
                 */
                cacheFlags: false,
                /**
                 * Allow fetching flags from the API (false = fetching is enabled)
                 * When false, the provider will fetch flags on mount and when getFlags() is called
                 * When true, it would only use serverState and never fetch updates
                 */
                preventFetch: false
            }}>
            {children}
        </FlagsmithProvider>
    );
}
